module.exports = __webpack_public_path__ + "img/homepage-banners-mazda-compliant-hyundai.4d528856.jpg";